import { Navigate, Outlet } from "react-router-dom";
import { useSessionStore } from "@/store/session";
import { LoadingState } from "@/components/common/loading-state";

export const ProtectedRoute = () => {
    const status = useSessionStore((state) => state.status);

    if (status === "checking") {
        return <LoadingState label="Verifying session…" className="min-h-screen" />;
    }

    if (status !== "authenticated") {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export const PublicOnlyRoute = () => {
    const status = useSessionStore((state) => state.status);

    if (status === "checking") {
        return <LoadingState label="Verifying session…" className="min-h-screen" />;
    }

    if (status === "authenticated") {
        return <Navigate to="/logs" replace />;
    }

    return <Outlet />;
};

